import { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import { GraphType, GraphDefaultProps, GraphRender } from '../common'
import { useTreeMapGraphModel } from './container/model'
import { useTreeMapGraphOption, TreeMapGraphOptions } from './container/options'
import { useTreeMapGraphRenderOption } from './container/render'
import { useTreeMapGraphEvents } from './container/event'

import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { TreemapChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

import {
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
} from 'echarts/components'

import { Box } from '@mui/material'

echarts.use([
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  TreemapChart,
  CanvasRenderer,
])

export const TreeMapGraph = <T,>({
  dashBoard,
  targetList,
  dataList,
  conditions,
  onChangeCondition,
  itemData,
  isResizing,
  graphRef,
  setCsv
}: GraphDefaultProps<T>) => {
  const { options, filterText } = itemData
  const { width, height, ref } = useResizeDetector()

  const graphOption = useTreeMapGraphOption({ dashBoard, options, targetList })
  const graphData = useTreeMapGraphModel({ dataList, conditions, filterText, graphOption })
  const renderOption = useTreeMapGraphRenderOption({ graphOption, graphData })
  const events = useTreeMapGraphEvents({ graphOption, onChangeCondition })

  useEffect(
    () => setCsv({ builder: () => graphData?.csvBuilder() }),
    [graphData, setCsv]
  )

  const { axisDef, valueDef } = graphOption
  return (
    <Box ref={ref} width="100%" height="100%">
      <GraphRender
        invalid={!graphData || isResizing || ((height ?? 0) <= 10)}
        dashBoard={dashBoard}
        keys={[axisDef?.key, valueDef?.key]}
      >
        {(width && height) ? (
          <ReactEChartsCore
            ref={graphRef}
            echarts={echarts}
            notMerge={true}
            onEvents={events}
            option={renderOption}
            opts={{ renderer: 'canvas' }}
            style={{ width, height }}
            theme="insite"
          />
        ) : <></>}
      </GraphRender>
    </Box>
  )
}

export const TreeMapGraphFactory: GraphType = {
  title: 'エリアグラフ',
  options: TreeMapGraphOptions,
  element: <T,>(props: GraphDefaultProps<T>) => <TreeMapGraph<T> {...props} />,
}
